import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    borderRadius: theme.borderRadii.sm,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    shadowColor: theme.colors.black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },
  text: {
    color: theme.colors.black,
    textAlign: 'center',
    verticalAlign: 'auto',
  },
  wrongBg: {
    backgroundColor: theme.colors.red,
  },
  lightColor: {
    color: theme.colors.lightGrey,
  },
  correctBg: {
    backgroundColor: theme.colors.primary,
  },
  hidden: {
    opacity: 0,
  },
  fontAbz: {
    fontFamily: 'ABeeZeeRegular',
  },
  letterContainer: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
});
